import { render } from "./GTDesigner.vue?vue&type=template&id=2a655b2e&scoped=true"
import script from "./GTDesigner.vue?vue&type=script&lang=js"
export * from "./GTDesigner.vue?vue&type=script&lang=js"

import "./GTDesigner.vue?vue&type=style&index=0&id=2a655b2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a655b2e"

export default script